import {
  REQUEST_ADD_PROVISIONAL_CLAIM,
  REQUEST_GET_PROVISIONAL_CLAIM,
  REQUEST_SET_PROVISIONAL_CLAIMS,
} from 'containers/ProvisionalClaimsPage/constants';

export const requestAddProvisionalClaim = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_ADD_PROVISIONAL_CLAIM,
  payload,
  successCallback,
});

export const requestGetProvisionalClaim = (page: number, limit: number) => ({
  type: REQUEST_GET_PROVISIONAL_CLAIM,
  page,
  limit,
});

export const setProvisionalClaim = (payload: any) => {
  return {
    type: REQUEST_SET_PROVISIONAL_CLAIMS,
    payload,
  };
};
